<!-- <re-captcha (resolved)="resolved($event)" siteKey="6LdnydMZAAAAAOSatgvcP2gHnEwDhRaH-b8KHzo4"></re-captcha> -->
<div class="container-fluid login-page">
    <div id="main-container">
        <div id="logo">
            <img src="assets/images/llwr.png" alt="logo" class="logo" />
            <div id="inner-container">
                <h1 class="title-color">Visual Logistics</h1>
                <div class="row vertical-center login-wrapper">
                    <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 vehiclecontainer">
                        <div class="vehicle">
                            <img style="vertical-align: middle;" src="assets/images/containers.png">
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12">
                        <p>&nbsp;</p>
                    </div>
                    <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 login-box ">
                        <div id="login" *ngIf="show_login">
                            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                                <div class="row form-group">
                                    <div class="col-lg-4 col-md-4 col-sm-5 col-xs-5">
                                        <label for="lgnControl_UserName" style="font-weight:100">Login ID :</label>
                                    </div>
                                    <div class="col-lg-8 col-md-8 col-sm-7 col-xs-7 text-center">
                                        <input type="text" formControlName="username" class="form-control text-uppercase">
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-lg-4 col-md-4 col-sm-5 col-xs-5">
                                        <label for="lgnControl_Password" style="font-weight:100">Password :</label>
                                    </div>
                                    <div class="col-md-8 col-md-8 col-sm-7 col-xs-7 text-center">
                                        <input [type]="type"  formControlName="password"
                                            class="form-control">
                                            <i class="far {{icon}} placeholder"class="placeholder" (click)="iconChange()"></i>
                                    </div>
                                </div>
                                <div *ngIf="false">
                                    <div class="col-md-8 col-md-8 col-sm-7 col-xs-7 text-center">
                                        <input type="loginFlag" formControlName="loginFlag" class="form-control">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <button type="submit" [disabled]="loginForm.invalid" class="btn btn-sub">Let Me
                                            In</button><br>
                                        <a (click)="forgotPw()">Forgot your password?</a>
                                    </div>
                                </div>
                                <div *ngIf="loading">loading...</div>
                                <pre *ngIf="message" style="text-align:center">{{message}}<br>{{defaultPage}}</pre>
                                <!-- <pre>Data Obtained is: {{ data | json }}</pre> -->
                            </form>
                        </div>
                        <div id="forgotPassword" *ngIf="!show_login">
                            <form [formGroup]="forgotPasswordForm" (ngSubmit)="forgotPasswordSubmit()">
                                <div class="row form-group">
                                    <div class="col-lg-4 col-md-4 col-sm-5 col-xs-5">
                                        <label for="lgnControl_email" style="font-weight:100">Login ID :</label>
                                    </div>
                                    <div class="col-lg-8 col-md-8 col-sm-7 col-xs-7 text-center">
                                        <input type="email" formControlName="email" class="form-control text-uppercase">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <button type="submit" [disabled]="forgotPasswordForm.invalid" class="btn btn-sub">Send password reset link</button>
                                    </div>
                                </div>
                                <div *ngIf="loading">loading...</div>
                                <div *ngIf="message" style="text-align:center">{{message}}<br>{{defaultPage}}</div>
                                <!-- <pre>Data Obtained is: {{ data | json }}</pre> -->
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <span class="spcl-text">Powered By</span>
                <img src="assets/images/elogistics.png">
            </div>
        </div>

    </div>

</div>
<div class="container-fluid lic-form">
    <div class="row justify-content-center">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 details">
            <!-- After clicking the button open the modal dialog using open/close event binding methods -->
            <!-- <button type="button" class="close" aria-label="Close" (click)="openModalDialog()"><span aria-hidden="true">&times;</span></button> -->
            <div class="backdrop" [ngStyle]="{'display':display}"></div>
            <!-- modal -->
            <div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':display}">
                <!-- modal-dialog -->
                <div class="modal-dialog" role="document">
                    <!-- modal-content -->
                    <div class="modal-content">
                        <!-- modal-header -->
                        <div class="modal-header">
                            <h4 class="modal-title">Info</h4>
                            <button type="button" class="close close-btn" aria-label="Close"
                                (click)="closeModalDialog()"><span aria-hidden="true">&times;</span></button>
                        </div>
                        <!-- modal-body -->
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 overflow-h">
                                    eLogistics has recently been updated. If you experience any issues please contact
                                    LLWR Transport Team by email consignments1@nuclearwasteservices.uk or phone 01946 383749
                                </div>
                            </div>


                        </div>
                        <!-- modal-footer -->
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default" (click)="closeModalDialog()">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div [ngStyle]="{'display':display}" class="gray-bg-modal model-backdrop-custom">
</div>